import { useSuspenseQuery } from '@tanstack/react-query'
import { zaf, isZendeskApp } from '@/features/zendesk-app'

export const zafClient = typeof window !== 'undefined' ? window.ZAFClient?.init() : undefined

/**
 * Hook for resolving ZAF Client with suspension when website embedded in Zendesk app.
 * The client script should be included in the HTML template:
 * https://developer.zendesk.com/api-reference/apps/apps-core-api/client_api/#zafclient-object
 * @returns Ready ZAF Client instance if Zendesk app and undefined when standalone website
 */
export function useZAFClient(): zaf.Client | null {
  const query = useSuspenseQuery({
    queryKey: ['zendesk', 'client'],
    queryFn: () => {
      return isZendeskApp()
        ? new Promise<zaf.Client>((resolve, reject) => {
            const wait = () => {
              if (!zafClient) {
                reject(new Error('ZAF Client not available.'))
              } else if (zafClient.ready) {
                resolve(zafClient)
              } else {
                setTimeout(wait)
              }
            }
            wait()
          })
        : null
    },
  })

  return query.data!
}
